import React from "react"
import styled, { css } from "styled-components"
import Img from "gatsby-image"

const tagColors = {
  highlight: "#F2BE22",
  sleep: "#B13DFF",
  flight: "#4A44F2",
  drive: "#00A653",
  extras: "#F23D91",
  eat: "#FF8100",
  stop: "#FF5C45",
}

const StyledItineraryCard = styled.div`
  display: flex;
  flex-direction: column;

  ${({ canExpand }) => {
    if (canExpand) {
      return css`
        cursor: pointer;

        &:hover ${StyledImg} {
          opacity: 0.7;
        }
      `
    }
    return null
  }}
`

const StyledImg = styled(Img)`
  margin-top: 10px;
  opacity: 1;
  transition: opacity 500ms ease-in;

  ${({ isExpanded }) => {
    if (isExpanded) {
      return css`
        opacity: 0.7;
      `
    }
  }}
`

export const Pill = styled.span`
  color: white;
  border-radius: 5px;
  padding: 3px 5px;
  font-family: "Libre Franklin";
  font-size: 10px;
  margin-right: 3px;
  ${props =>
    css`
      background-color: ${tagColors[props.tag] || "#4A44F2"};
    `}
`
const PillWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 16px;
  margin-bottom: 7px;
`

const PillContainer = styled.div`
  height: 16px;
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 5px;
  position: absolute;
`

const PillHR = styled.hr`
  border-bottom: 1px solid #fbe3e5;
  width: 100%;
  border-top: none;
`

const Content = styled.div`
  font-family: "Playfair Display";
  padding: 0 10px 12px 10px;
  display: flex;
  flex-direction: column;
`

const ItineraryCard = ({
  activity,
  image,
  setExpanded,
  canExpand,
  isExpanded,
}) => {
  return (
    <StyledItineraryCard canExpand={canExpand}>
      <PillWrapper>
        <PillHR />
        <PillContainer>
          {activity.tags.map(tag => (
            <Pill key={tag} tag={tag}>
              {tag}
            </Pill>
          ))}
        </PillContainer>
      </PillWrapper>
      <Content
        onClick={() => {
          canExpand && setExpanded(activity)
        }}
      >
        <p>{activity.label}</p>
        {image && <StyledImg fixed={image} isExpanded={isExpanded} />}
      </Content>
    </StyledItineraryCard>
  )
}

export default ItineraryCard
